import { EncounterStartType, VisitType } from "@/api/generated/models";

// follow_up has no purchasable encounter type.
export const ENCOUNTER_TYPE_BY_VISIT_TYPE: Partial<
  Record<VisitType, EncounterStartType>
> = {
  [VisitType.live_chat]: EncounterStartType.TEXT_BASED,
  [VisitType.live_video]: EncounterStartType.AUDIOVISUAL,
  [VisitType.async_rx]: EncounterStartType.ASYNC_RX,
  [VisitType.async_dx]: EncounterStartType.ASYNC_DX,
  [VisitType.rx_renewal]: EncounterStartType.RX_RENEWAL,
};

export const VISIT_TYPE_BY_ENCOUNTER_TYPE: Record<
  EncounterStartType,
  VisitType
> = {
  [EncounterStartType.TEXT_BASED]: VisitType.live_chat,
  [EncounterStartType.AUDIOVISUAL]: VisitType.live_video,
  [EncounterStartType.ASYNC_RX]: VisitType.async_rx,
  [EncounterStartType.ASYNC_DX]: VisitType.async_dx,
  [EncounterStartType.RX_RENEWAL]: VisitType.rx_renewal,
};
